import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import CgnBadge from "../toolbox/CgnBadge";
import CgnAlert from "../toolbox/CgnAlert";
import CgnDatatable from "../toolbox/CgnDatatable";
import CgnMessage from "../toolbox/CgnMessage";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import { URL } from "../../redux/actions/constants";
import CgnButtonDropdown from "../toolbox/CgnButtonDropdown";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import CgnButton from "../toolbox/CgnButton";

class SupplierList extends Component {
  state = {
    pageTitle: "Tedarikçi Listele",
    pageAddLink: "tedarikci-ekle",
    pageUpdateLink: "tedarikci-guncelle",
    pageDetailLink: "tedarikci-detay",
    pageListLink: "tedarikci-listele",
    breadcrumb: [{ text: "Tedarikçi", link: "#" }],
    isLoading: false,
    isDeleted: false,
    status: false,
    supplierData: [],
    alertErrorMessage: "",
    districtGuid: "00000000-0000-0000-0000-000000000000",
    townGuid: "00000000-0000-0000-0000-000000000000",
    cityGuid: "00000000-0000-0000-0000-000000000000",
    countryGuid: "00000000-0000-0000-0000-000000000000",
    districtArr: [],
    townArr: [],
    cityArr: [],
    countryArr: [],
    isCityTrue: true,
    isDistrictTrue: true,
    isTownTrue: true,
    labelIsTurkey: false,
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var statusType = 1; // 1 aktif ve pasiflerin ikisinide getirmesi için
    await axios
      .get(URL + "/countries/getlist", config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          countryArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });

    this.getList();
  }

  handleDelete = (guid) => {
    confirmAlert({
      title: CgnMessage.deleteQuestionTitle,
      message: CgnMessage.deleteQuestionMessage,
      buttons: [
        {
          label: CgnMessage.deleteQuestionYes,
          onClick: () => this.deleteItem(guid),
        },
        {
          label: CgnMessage.deleteQuestionNo,
        },
      ],
    });
  };

  getList = async () => {
    this.setState({
      isLoading: true,
    });

    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var URLParam = "";
    var statusType = 1;
    URLParam =
      "/suppliers/getlistsupplier/" +
      statusType +
      "/" +
      this.state.countryGuid +
      "/" +
      this.state.cityGuid +
      "/" +
      this.state.townGuid +
      "/" +
      this.state.districtGuid;

    await axios
      .get(URL + URLParam, config)
      .then((response) => {
        this.setState({
          supplierData: response.data,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
  };

  async handleCountrySelectChange(option) {
    this.setState({
      isLoading: true,
    });
    if (option) {
      await this.setState({
        countryGuid: option.value,
        isCityTrue: false,
        countryError: "",
        alertErrorMessage: "",
      });
      if (option.label === "TÜRKİYE") {
        this.setState({
          labelIsTurkey: true,
        });
      }
      if (option.label !== "TÜRKİYE") {
        this.setState({
          isCityTrue: true,
          isTownTrue: true,
          isDistrictTrue: true,
          labelIsTurkey: false,
          isLoading: false,
          cityGuid: "00000000-0000-0000-0000-000000000000",
          townGuid: "00000000-0000-0000-0000-000000000000",
          districtGuid: "00000000-0000-0000-0000-000000000000",
          cityError: "",
          townError: "",
          districtError: "",
        });
      }
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      await axios
        .get(URL + "/cities/getlist/" + option.value, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: item.name,
            };
          });
          this.setState({
            cityArr: myArr,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        countryGuid: "",
        isCityTrue: true,
        isTownTrue: true,
        isDistrictTrue: true,
        isLoading: false,
        cityGuid: "00000000-0000-0000-0000-000000000000",
        townGuid: "00000000-0000-0000-0000-000000000000",
        districtGuid: "00000000-0000-0000-0000-000000000000",
        cityError: "",
        townError: "",
        districtError: "",
        countryError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  async handleCitySelectChange(option) {
    this.setState({
      isLoading: true,
    });
    if (option) {
      await this.setState({
        cityGuid: option.value,
        isTownTrue: false,
        cityError: "",
        alertErrorMessage: "",
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      await axios
        .get(URL + "/towns/getlist/" + option.value, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: item.name,
            };
          });
          this.setState({
            townArr: myArr,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        cityGuid: "",
        isTownTrue: true,
        isDistrictTrue: true,
        isLoading: false,
        townGuid: "00000000-0000-0000-0000-000000000000",
        districtGuid: "00000000-0000-0000-0000-000000000000",
        townError: "",
        districtError: "",
        cityError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  async handleTownSelectChange(option) {
    this.setState({
      isLoading: true,
    });
    if (option) {
      this.setState({
        townGuid: option.value,
        isDistrictTrue: false,
        townError: "",
        alertErrorMessage: "",
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      await axios
        .get(URL + "/districts/getlist/" + option.value, config)
        .then((response) => {
          var myArr = response.data.map(function (item) {
            return {
              value: item.guid,
              label: item.name,
            };
          });
          this.setState({
            districtArr: myArr,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        townGuid: "",
        isDistrictTrue: true,
        districtGuid: "00000000-0000-0000-0000-000000000000",
        districtError: "",
        isLoading: false,
        townError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  async handleDistrictSelectChange(option) {
    if (option) {
      this.setState({
        districtGuid: option.value,
        districtError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        districtGuid: "00000000-0000-0000-0000-000000000000",
        districtError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  async deleteItem(guid) {
    this.setState({
      isLoading: true,
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    const URLParam = "/suppliers/delete";
    const obj = {
      guid,
    };
    axios
      .post(URL + URLParam, obj, config)
      .then(() => {
        confirmAlert({
          title: CgnMessage.alertSuccessTitle,
          message: CgnMessage.deleteSuccessMessage,
          buttons: [
            {
              label: CgnMessage.closeButton,
              onClick: () => {
                window.location.reload();
              }
            },
          ],
        });
      })
      .catch((error) => {
        confirmAlert({
          title: CgnMessage.alertErrorTitle,
          message: error.response.data,
          buttons: [
            {
              label: CgnMessage.closeButton,
              onClick: () => {
                this.setState({
                  isLoading: false,
                });
              }
            },
          ],
        });
      });
  }

  thStyle = {
    width: "150px",
  };

  thStyle2 = {
    width: "75px",
  };

  tdStyle = {
    width: "400px",
  };

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row className="supplierList" id="list">
          <Col>
            <Card body>
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title={CgnMessage.alertErrorTitle}
                  text={this.state.alertErrorMessage}
                />
              )}
              <Row className="filterRow">
                <Col className="pl-2 pr-2">
                  <CgnReactSelect
                    name="countryGuid"
                    label="Ülke"
                    placeholder="Lütfen ülke seçiniz..."
                    selectValue={this.state.countryGuid}
                    isMulti={false}
                    isClearable={true}
                    onChange={(option) =>
                      this.handleCountrySelectChange(option)
                    }
                    options={this.state.countryArr}
                  //error={this.state.countryError}
                  />
                </Col>
                <Col className="pl-2 pr-2">
                  <CgnReactSelect
                    name="cityGuid"
                    label="Şehir"
                    placeholder="Lütfen şehir seçiniz..."
                    selectValue={this.state.cityGuid}
                    isMulti={false}
                    isClearable={true}
                    disabled={this.state.isCityTrue}
                    onChange={(option) => this.handleCitySelectChange(option)}
                    options={this.state.cityArr}
                  //error={this.state.cityError}
                  />
                </Col>
                <Col className="pl-2 pr-2">
                  <CgnReactSelect
                    name="townGuid"
                    label="İlçe"
                    placeholder="Lütfen ilçe seçiniz..."
                    selectValue={this.state.townGuid}
                    isMulti={false}
                    isClearable={true}
                    disabled={this.state.isTownTrue}
                    onChange={(option) => this.handleTownSelectChange(option)}
                    options={this.state.townArr}
                  //error={this.state.townError}
                  />
                </Col>
                <Col className="pl-2 pr-2">
                  <CgnReactSelect
                    name="districtGuid"
                    label="Mahalle"
                    placeholder="Lütfen mahalle seçiniz..."
                    selectValue={this.state.districtGuid}
                    isMulti={false}
                    isClearable={true}
                    disabled={this.state.isDistrictTrue}
                    onChange={(option) =>
                      this.handleDistrictSelectChange(option)
                    }
                    options={this.state.districtArr}
                  //error={this.state.districtError}
                  />
                </Col>
                <Col className="pl-2 pr-0">
                  <CgnButton
                    type="button"
                    color="primary"
                    onClick={this.getList}
                    text="Listele"
                    className="listButton"
                  />
                </Col>
              </Row>
              <CgnDatatable
                data={this.state.supplierData}
                title={this.state.pageTitle}
                columns={[
                  {
                    name: "Tedarikçi Bilgileri",
                    sortable: false,
                    cell: (row) => {
                      var phone = row.phone,
                        maskPhone = phone ? `${phone.substring(0, 1)}  ${"(" + phone.substring(1, 4) + ")"
                          } ${phone.substring(4, 7)} ${phone.substring(
                            7,
                            9
                          )} ${phone.substring(9, 11)}` : "";
                      return (
                        <Table className="table table-responsive ">
                          <tbody>
                            <tr>
                              <th style={this.thStyle}>Tedarikçi</th>
                              {/* <th className="colon">:</th> */}
                              <td colSpan={3} style={this.tdStyle}>{row.name}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Telefon</th>
                              {/* <th className="colon">:</th> */}
                              <td style={this.tdStyle}>{row.phone === "" ? "-" : maskPhone}</td>
                              <th style={this.thStyle2}>E-Mail</th>
                              {/* <th className="colon">:</th> */}
                              <td>{row.eMail !== "" ? row.eMail : "-"}</td>
                            </tr>
                            <tr>
                              <th style={this.thStyle}>Ekleyen Kullanıcı</th>
                              {/* <th className="colon">:</th> */}
                              <td colSpan={3}>{row.createdBy}</td>
                            </tr>
                          </tbody>
                        </Table>
                      );
                    },
                  },
                  {
                    selector: "status",
                    width: "110px",
                    padding: "0px",
                    sortable: false,
                    cell: (row) => {
                      if (row.status) {
                        return <CgnBadge color="success" text="Aktif" />;
                      } else {
                        return <CgnBadge color="danger " text="Pasif" />;
                      }
                    },
                  },
                  {
                    ignoreRowClick: true,
                    allowOverflow: true,
                    button: true,
                    cell: (row, cell) => (
                      <CgnButtonDropdown
                        label={"Yönet"}
                        className="mr-0"
                        color="primary"
                        items={[
                          {
                            text: CgnMessage.updateButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageUpdateLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.detailButton,
                            className: "dropDownBtn",
                            href: `/${this.state.pageDetailLink}/${row.guid}`,
                          },
                          {
                            text: CgnMessage.deleteButton,
                            className: "dropDownBtn",
                            onClick: () => this.handleDelete(row.guid),
                          },
                        ]}
                      />
                    ),
                  },
                ]}
                loading={this.state.isLoading}
              />
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default SupplierList;
